// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"m2-z","dimensionLabel":"n2-z","styleChooserControlWrapper":"o2-z","styleChooserControl":"p2-z","disabled":"q2-z","giftCard":"r2-z","styleChooserText":"s2-z"};